<template>
  <!-- Header -->
  <header
    class="z-10 py-4 bg-white shadow-sm dark:bg-gray-800 border-b dark:border-gray-700"
  >
    <div
      class="container flex items-center justify-between h-full px-6 mx-auto"
    >
      <!-- Toggle sidebar button -->
      <button
        @click="$emit('toggle-sidebar')"
        class="p-1 mr-5 -ml-1 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
        aria-label="Toggle Menu"
      >
        <svg
          class="w-6 h-6 text-gray-600 dark:text-gray-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
      </button>

      <!-- Search input -->
      <!-- <div class="flex justify-center flex-1 lg:mr-32">
        <div class="relative w-full max-w-xl mr-6 focus-within:text-blue-500">
          <div class="absolute inset-y-0 flex items-center pl-2">
            <svg
              class="w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <input
            class="w-full pl-8 pr-2 py-2 text-sm text-gray-700 bg-gray-100 rounded-md border-0 focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 dark:text-gray-200"
            type="text"
            placeholder="Pesquisar"
            aria-label="Pesquisar"
          />
        </div>
      </div> -->

      <ul class="flex items-center flex-shrink-0 space-x-6">
        <!-- Dark mode toggle -->
        <li class="flex">
          <button
            @click="$emit('toggle-dark-mode')"
            class="rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            aria-label="Toggle dark mode"
          >
            <svg
              v-if="isDark"
              class="w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            <svg
              v-else
              class="w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
              />
            </svg>
          </button>
        </li>
        <!-- Suporte via WhatsApp -->
        <li>
          <a
            :href="whatsappSupportLink('Olá! Preciso de ajuda com o Avalioo.')"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-green-700 bg-green-100 border border-green-300 rounded-md hover:bg-green-200 dark:bg-green-900 dark:text-green-300 dark:border-green-700 dark:hover:bg-green-800 transition-all"
          >
            <svg class="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M20.52 3.48A11.74 11.74 0 0012.05 1C6.17 1 .99 6.17.99 12.05a11.76 11.76 0 001.67 6.08L1 23l5.09-1.66a11.76 11.76 0 005.97 1.63h.05c5.88 0 11.06-5.18 11.06-11.06 0-3-.96-5.8-2.75-7.89zm-8.47 17.3h-.04a10.13 10.13 0 01-5.21-1.43l-.37-.22-3.03.98 1-2.95-.24-.38a10.12 10.12 0 01-1.57-5.45c0-5.6 4.56-10.16 10.16-10.16a10.1 10.1 0 017.16 2.98 9.99 9.99 0 012.98 7.14c0 5.6-4.56 10.16-10.14 10.16zm5.52-7.56c-.3-.15-1.78-.88-2.05-.98-.27-.1-.46-.15-.65.15s-.75.98-.92 1.18c-.17.2-.34.22-.63.07a8.24 8.24 0 01-2.41-1.5 9.03 9.03 0 01-1.66-2.06c-.17-.3 0-.46.13-.61.13-.14.3-.34.45-.5.15-.17.2-.3.3-.5.1-.2.05-.38-.02-.53-.07-.15-.65-1.56-.89-2.14-.23-.56-.47-.48-.65-.48h-.56c-.18 0-.46.07-.7.34s-.92.9-.92 2.2c0 1.3.94 2.56 1.07 2.74.13.17 1.82 2.78 4.41 3.89.62.27 1.1.43 1.47.55.62.2 1.2.17 1.65.1.5-.08 1.54-.63 1.76-1.25.23-.62.23-1.15.16-1.25-.07-.1-.26-.16-.56-.3z"
              />
            </svg>
            Atendimento
          </a>
        </li>

        <!-- Notifications menu -->
        <!-- <li class="relative">
          <button
            @click="toggleNotifications"
            class="relative align-middle rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            aria-label="Notifications"
          >
            <svg
              class="w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
            </svg> -->
        <!-- Notification badge -->
        <!-- <span
              v-if="hasNotifications"
              class="absolute top-0 right-0 inline-block w-2 h-2 transform translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full"
            ></span>
          </button>
           -->
        <!-- Notifications dropdown -->
        <!-- <div
            v-show="notificationsOpen"
            class="absolute right-0 w-64 mt-2 origin-top-right bg-white dark:bg-gray-800 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
          >
            <div class="py-2 px-3 border-b dark:border-gray-700 flex justify-between items-center">
              <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">Notificações</span>
              <button class="text-xs text-blue-500 hover:text-blue-600 dark:hover:text-blue-400">
                Marcar todas como lidas
              </button>
            </div>
            <div v-if="notifications.length > 0" class="py-2">
              <div
                v-for="(notification, i) in notifications"
                :key="i"
                class="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <p class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ notification.title }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ notification.time }}</p>
              </div>
            </div>
            <div v-else class="py-3 px-3 text-center text-sm text-gray-500 dark:text-gray-400">
              Nenhuma notificação no momento
            </div>
          </div>
        </li> -->

        <!-- Profile menu -->
        <li class="relative">
          <button
            @click="toggleProfileMenu"
            class="flex items-center focus:outline-none"
            aria-label="Account"
            aria-haspopup="true"
          >
            <div
              class="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-medium"
            >
              {{ userInitials }}
            </div>
            <span
              class="ml-2 text-sm font-medium text-gray-700 dark:text-gray-200"
              >{{ userName }}</span
            >
            <svg
              class="w-4 h-4 ml-1 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          <!-- Profile dropdown -->
          <div
            v-show="profileMenuOpen"
            class="absolute right-0 w-48 mt-2 py-1 origin-top-right bg-white dark:bg-gray-800 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
          >
            <!-- <router-link
              to="/profile"
              class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              Perfil
            </router-link>
            <router-link
              to="/settings"
              class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              Configurações
            </router-link> -->
            <div class="border-t dark:border-gray-700"></div>
            <router-link
              to="/logout"
              class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              Sair
            </router-link>
          </div>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useWhatsappSupport } from "@/modules/shared/composables/useWhatsappSupport";

export default {
  name: "HeaderComponent",
  props: {
    isDark: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["toggle-sidebar", "toggle-dark-mode"],
  setup() {
    const authStore = useAuthStore();
    const notificationsOpen = ref(false);
    const profileMenuOpen = ref(false);
    const hasNotifications = ref(false);
    const userName = ref("");
    const { whatsappSupportLink } = useWhatsappSupport();

    const notifications = ref([
      {
        title: "Nova avaliação recebida",
        time: "Há 5 minutos",
      },
      {
        title: "Relatório mensal disponível",
        time: "Há 2 horas",
      },
    ]);

    // Função para buscar os dados do usuário
    const fetchUserData = () => {
      if (authStore.user) {
        userName.value =
          authStore.user.username || authStore.user.email || "Usuário";
      } else {
        userName.value = "Usuário";
      }
    };

    const userInitials = computed(() => {
      const name = userName.value || "";
      return name
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
    });

    // Alternar notificações
    const toggleNotifications = () => {
      notificationsOpen.value = !notificationsOpen.value;
      profileMenuOpen.value = false;
    };

    // Alternar menu de perfil
    const toggleProfileMenu = () => {
      profileMenuOpen.value = !profileMenuOpen.value;
      notificationsOpen.value = false;
    };

    // Fechar menus ao clicar fora
    const closeMenus = (e) => {
      if (!e.target.closest("button")) {
        notificationsOpen.value = false;
        profileMenuOpen.value = false;
      }
    };

    // Inicialização
    onMounted(() => {
      // Adicionar listener para fechar menus
      document.addEventListener("click", closeMenus);

      // Buscar dados do usuário
      fetchUserData();

      // Definir notificações (para demo)
      hasNotifications.value = notifications.value.length > 0;
    });

    // Limpeza
    onUnmounted(() => {
      document.removeEventListener("click", closeMenus);
    });

    return {
      userName,
      userInitials,
      notificationsOpen,
      profileMenuOpen,
      hasNotifications,
      notifications,
      toggleNotifications,
      toggleProfileMenu,
      whatsappSupportLink,
    };
  },
};
</script>
